import { Injectable } from '@angular/core';
import { CoverpathControllerInterface } from '../../interfaces/controller/CoverpathControllerInterface';
import { TwoFactorAuthStatus } from '../../classes/TwoFactorAuthStatus';
import { AmorphicService } from '../amorphic/amorphic.service';

import { CoverpathCustomer } from '../../../../coverpath-common/classes/coverpath_subclasses/CoverpathCustomer';
import { CPLogger } from '../../../../common/js/logger/CPLogger';

@Injectable()
export class TwoFactorAuthService {
  controller: CoverpathControllerInterface;

  constructor(private amorphicService: AmorphicService) {
    this.controller = amorphicService.controller;
  }

  sendTFACodeToPhone(method: string, resend: boolean): Promise<TwoFactorAuthStatus | void> {
    return this.controller.tfaController.publicSendTFACodeToPhone(
      method,
      resend,
      this.controller.customer as CoverpathCustomer
    );
  }

  submitAndVerifyTFACode(submittedCode: number): Promise<TwoFactorAuthStatus> {
    return this.controller.tfaController.publicSubmitAndVerifyTFACode(
      submittedCode,
      this.controller.customer as CoverpathCustomer
    );
  }

  getTFAPhone(): Promise<string> {
    return this.controller.tfaController.getMaskedTFAPhone(this.controller.customer as CoverpathCustomer);
  }
}
